import React from "react";
import { StyledShamanDog } from "./styledComponents/Containers";

export default function ShamanDog() {
  return <StyledShamanDog>
    {/* <div class="bubble-dog">Everyone’s welcome in our cozy corner of Web3 #SportFi.</div> */}
    <img className="shamman-dog animate__animated animate__zoomIn animate__slower" src="./home_background.png"/>
  </StyledShamanDog>;
}
